import { createContext } from 'react';
import { IItemForGetShortInfo, IItemForGetShortInfoWithStatus, IUpdateCategoryRestaurantProperties } from 'types';

export type TTypeOfModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'saveAsPatch'
	| 'success'
	| 'error';

export interface IEditCategoryRestaurantPropertiesState {
	needRefetchRestaurantPropertiesData: boolean;
	customerName: string;
	fetchedRestaurants: IItemForGetShortInfoWithStatus[];
	IDSelectedRestaurant: Nullable<string>;
	categoryId: string;
	categoryName: string;
	subcategories: IItemForGetShortInfo[];
	hasSchedulePriority: boolean;
	activationSchedule: string;
	deactivationSchedule: string;
	dataForSubmit: Nullable<IUpdateCategoryRestaurantProperties>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const editCategoryRestaurantPropertiesInitialState: IEditCategoryRestaurantPropertiesState = {
	needRefetchRestaurantPropertiesData: false,
	customerName: '',
	fetchedRestaurants: [],
	IDSelectedRestaurant: null,
	categoryId: '',
	categoryName: '',
	subcategories: [],
	hasSchedulePriority: false,
	activationSchedule: '',
	deactivationSchedule: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditCategoryRestaurantPropertiesContext extends IEditCategoryRestaurantPropertiesState {
	refetchRestaurantPropertiesData(value: boolean): void;
	setIDRestaurant(value: Nullable<string>): void;
	changeActivationSchedule(value: string): void;
	changeDeactivationSchedule(value: string): void;
	setDataForSubmit(data: IUpdateCategoryRestaurantProperties): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
}

export const EditCategoryRestaurantPropertiesContext = createContext<IEditCategoryRestaurantPropertiesContext>({
	refetchRestaurantPropertiesData: () => undefined,
	setIDRestaurant: () => undefined,
	changeActivationSchedule: () => undefined,
	changeDeactivationSchedule: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	...editCategoryRestaurantPropertiesInitialState,
});
